import React from 'react';
import { FaBriefcase, FaLaptopCode, FaUserGraduate } from 'react-icons/fa';
import '../css/Experience.css';

const Experience = () => {
  return (
    <section id="experience" className="experience-section">
      <h1>Work Experience</h1>

      <div className="experience-grid">
        {/* CARD #1 – Updated Role */}
        <div className="job-card">
          <div className="card-header">
            <span className="job-icon">
              <FaBriefcase />
            </span>
            <h2>Full Stack Developer | AI & Web Projects</h2>
            <span className="job-dates">October 2024 – Present | Toronto, Canada</span>
          </div>
          <div className="card-body">
            <ul>
              <li>Created an AI-powered ZIP-upload tool using React and Ollama to automate linting, test generation, and refactoring suggestions; reduced manual QA and doc effort by 40% across 3 engineering teams.</li>
              <li>Built a WhatsApp voice cloning platform using React and FastAPI with selfie-based JWT authentication; integrated YourTTS + HiFi-GAN to generate real-time multilingual messages, achieving 500+ user interactions in the first month.</li>
              <li>Developed a personal AI assistant with Gmail, Calendar, and iMessage integration; reduced daily task handling time by ~30% through automated scheduling, email replies, and system monitoring used actively by 10+ internal team members.</li>
              <li>Built a multilingual mechanic booking platform with React and i18n.js (6 languages); enhanced SEO by implementing structured metadata with React Helmet and submitting sitemaps via Google Search Console.</li>
              <li>Delivered 5+ full-stack internal tools with secure auth and RBAC using Flask and Express.js; reduced manual processing time by 40% for internal workflows.</li>
              <li>Developed 4+ responsive UIs using React and Tailwind; boosted engagement by 25% through animated components and streamlined contact via EmailJS API integration.</li>
            </ul>
          </div>
        </div>

        {/* CARD #2 */}
        <div className="job-card">
          <div className="card-header">
            <span className="job-icon">
              <FaLaptopCode />
            </span>
            <h2>Backend Developer | TrioTech Web</h2>
            <span className="job-dates">August 2024 – October 2024 | Calgary, Canada</span>
          </div>
          <div className="card-body">
            <ul>
              <li>Built a full-stack messaging system with a React frontend and Flask backend, enabling secure authentication (JWT), data validation, and MongoDB integration.</li>
              <li>Developed a secure backend for an invoice management application using Express.js and MongoDB, with role-based access control and scalable RESTful APIs.</li>
              <li>Led the development of an eCommerce platform with product and order management features, secure user authentication, and efficient cart handling.</li>
            </ul>
          </div>
        </div>

        {/* CARD #3 */}
        <div className="job-card">
          <div className="card-header">
            <span className="job-icon">
              <FaLaptopCode />
            </span>
            <h2>Full Stack Developer | Koyuncu Elektronik</h2>
            <span className="job-dates">December 2023 – August 2024 | Istanbul, Turkey</span>
          </div>
          <div className="card-body">
            <ul>
              <li>Revamped B2B e-commerce portals using React.js and Node.js, improving dealer order processing by 30%.</li>
              <li>Integrated logistics APIs (Samsung, TP-Link) to automate inventory tracking, reducing supply chain delays by 20%.</li>
              <li>Designed a JWT-secured authentication system for dealer portals, ensuring data security compliance with ISO 27001 standards.</li>
            </ul>
          </div>
        </div>

        {/* CARD #4 */}
        <div className="job-card">
          <div className="card-header">
            <span className="job-icon">
              <FaLaptopCode />
            </span>
            <h2>Junior Backend Developer | Ozkoyuncu Madencilik A.S</h2>
            <span className="job-dates">April 2023 – December 2023 | Kayseri, Turkey</span>
          </div>
          <div className="card-body">
            <ul>
              <li>Developed RESTful APIs for mining equipment sensor integration, enabling real-time monitoring of 2M+ tons/year iron ore production.</li>
              <li>Optimized MongoDB queries for geological data storage, improving report generation speed by 35%.</li>
              <li>Collaborated on ERP system modernization, enhancing inventory and shipment tracking.</li>
            </ul>
          </div>
        </div>

        {/* CARD #5 */}
        <div className="job-card">
          <div className="card-header">
            <span className="job-icon">
              <FaUserGraduate />
            </span>
            <h2>Backend Developer – Intern | Ozkoyuncu Madencilik A.S</h2>
            <span className="job-dates">May 2022 – August 2022 | Kayseri, Turkey</span>
          </div>
          <div className="card-body">
            <ul>
              <li>Automated Python scripts for quality control reporting, reducing manual workload by 50%.</li>
              <li>Supported Express.js/SQL backend development for enrichment plant dashboards, improving data visibility for operational teams.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
